export const SUBJECT_CHOICES = [
  {
    title: 'Primary subject',
    choices: [
      { code: 'COMBINED_MATHS', label: 'Combined Mathematics' },
      { code: 'BIOLOGY', label: 'Biology' },
    ],
  },
  {
    title: 'Additional subject',
    choices: [
      { code: 'CHEMISTRY', label: 'Chemistry' },
      { code: 'ICT', label: 'Information and Communication Technology (ICT)' },
    ],
  },
] as const;
